var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.727V2h5.267v.938h-4.21v2.948h3.937v.938H4.057V9.79h4.278v.937H3z",
    fill: "#500d76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngress);
export default __webpack_public_path__ + "static/media/engress.e04cbcb048f3c2835c53612b3b1622d2.svg";
export { ForwardRef as ReactComponent };